import React, { useContext, useState, useEffect } from "react";

import { useForm, Controller } from "react-hook-form";
import API from "../../../services/api";
import { AuthContext } from "../../../contexts/AuthProvider";

import facebookMetrics from "../../../services/facebookMetrics.json";

import { Form } from "./style";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";

export default function FBReachExtractor(props) {
  const { currentUser } = useContext(AuthContext);
  const api = new API(currentUser);

  const dateExpiration = new Date();
  dateExpiration.setMonth(dateExpiration.getMonth() + 6);

  const breakdownfb = facebookMetrics.breakdowns;
  const actionBreakdownfb = facebookMetrics.action_breakdown;
  const fieldsfb = facebookMetrics.fields;

  const fixedOptions = [fieldsfb[59]];
  const [fields, setFields] = useState([...fixedOptions]);
  const [clearBreakDowns, setClearBreakDowns] = useState([]);
  const [clearActionBreakdown, setClearActionBreadown] = useState([]);

  const { register, handleSubmit, reset, control } = useForm({
    defaultValues: {
      customers: "",
      level: "",
      accountId: "",
      nomeExtraction: "",
      date: "",
      description: "",
      consolidationWindow: "",
    },
  });

  function completeExtraction() {
    Array.from(document.querySelectorAll("input")).forEach(
      (input) => (input.value = "")
    );

    Array.from(document.querySelectorAll("select")).forEach(
      (option) => (option.value = "")
    );

    Array.from(document.querySelectorAll("textarea")).forEach(
      (textarea) => (textarea.value = "")
    );

    reset();
    clearSelected();
  }

  function platformPayload(bodyFBReach) {
    return bodyFBReach;
  }

  function formatWords(word) {
    const wordFormat = word
      .normalize("NFD")
      .replace(/ /g, "_")
      .replace(/([\u0300-\u036f]|[^0-9a-zA-Z-_])/g, "")
      .replace("-", "_")
      .toLowerCase();
    return wordFormat;
  }

  const sendExtraction = (event) => {
    props.setModalController("create extraction");

    const bodyFBReach = {
      metadata: {
        extractionName: formatWords(event.nomeExtraction),
        author: currentUser.email,
        customer: formatWords(event.customers),
        creationDate: new Date().toISOString(),
        expirationDate: dateExpiration.toISOString().slice(0, 10),
        consolidationWindow: Number(event.consolidationWindow),
        precisionInterval: 30,
        extractorModule: "fbReachExtractor",
        startDate: event.date,
      },
      queryParams: {
        accountId: `act_${event.accountId}`,
        breakdowns: clearBreakDowns,
        action_breakdowns: clearActionBreakdown,
        fields: fields,
        level: event.level,
        seasonality: event.seasonality,
      },
      destination: {
        projectId: process.env.REACT_APP_DEFAULT_PROJECT_BQ,
        datasetId: formatWords(event.customers),
        tableId: `${"fbReachExtractor"}-${formatWords(
          event.customers
        )}-${formatWords(event.nomeExtraction)}`,
        description: event.description,
      },
    };

    api
      .createDailyExtraction(platformPayload(bodyFBReach))
      .then(() => {
        props.setModalController("create extraction complete");
        completeExtraction();
      })
      .catch((error) => {
        if (error.request.status === 400) {
          props.setNewError(error.data.error);
          props.setModalController("error campo");
        } else {
          props.setModalController("error report");
        }
      });
  };

  const clearSelected = () => {
    setFields([]);
    setClearBreakDowns([]);
    setClearActionBreadown([]);
  };

  return (
    <Form onSubmit={handleSubmit(sendExtraction)}>
      <label htmlFor="cliente">Cliente</label>
      <select id="cliente" {...register("customers")} required selected>
        <option value="">Escolha o nome do cliente.</option>
        {props.clients !== undefined &&
          props.clients.map((option) => {
            return (
              <option key={option.id} value={option.name}>
                {option.name}
              </option>
            );
          })}
      </select>

      <label htmlFor="level">Level</label>
      <select id="level" required {...register("level")}>
        <option value="">selecione ad/campaign</option>
        <option value="ad">ad</option>
        <option value="campaign">campaign</option>
      </select>

      <label htmlFor="accountId">{"Account Id"}</label>
      <input
        required
        id="accountId"
        placeholder={"Ex: 123456789"}
        name="accountId"
        {...register("accountId")}
      />

      <label htmlFor="nomeExtraction">Nome da extração</label>
      <input
        required
        id="nomeExtraction"
        placeholder="Ex: Cliente_productPerformance"
        name="nomeExtraction"
        {...register("nomeExtraction")}
      />

      <label htmlFor="seasonality">Sazonalidade</label>
      <select id="seasonality" required {...register("seasonality")}>
        <option value={"MONTH"}>MONTH</option>
        <option value={"WEEKLY"}>WEEKLY</option>
      </select>

      <label htmlFor="consolidationWindow">Janela de consolidação</label>
      <select
        id="consolidationWindow"
        required
        {...register("consolidationWindow")}
      >
        <option value="">Selecione a janela de consolidação.</option>
        <option value={45}>45 dias</option>
        <option value={30}>30 dias</option>
        <option value={15}>15 dias</option>
        <option value={7}>7 dias</option>
        <option value={4}>4 dias</option>
        <option value={2}>2 dias</option>
      </select>

      <Stack spacing={2}>
        <label htmlFor="actionBreakdown">Action Breakdown</label>
        <Controller
          control={control}
          name="actionBreakdown"
          render={({ field: { onChange, value } }) => (
            <Autocomplete
              id="actionBreakdown"
              multiple
              options={actionBreakdownfb ?? []}
              value={clearActionBreakdown ?? []}
              onChange={(event, values) => {
                onChange(values);
                setClearActionBreadown([...values]);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  classes={{ root: "MuiTextField-root" }}
                  placeholder="Adicione seus Actions Breakdowns"
                  onChange={onChange}
                />
              )}
            />
          )}
        />

        <label htmlFor="breakdown">Breakdown</label>
        <Controller
          control={control}
          name="breakdowns"
          render={({ field: { onChange, value } }) => (
            <Autocomplete
              id="breakdown"
              multiple
              options={breakdownfb}
              value={clearBreakDowns}
              onChange={(event, values) => {
                onChange(values);
                setClearBreakDowns([...values]);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  classes={{ root: "MuiTextField-root" }}
                  placeholder="Adicione seus breakdowns"
                  onChange={onChange}
                />
              )}
            />
          )}
        />

        <label htmlFor="fields">Fields</label>
        <Controller
          control={control}
          name="fields"
          render={({ field: { onChange, values } }) => (
            <Autocomplete
              multiple
              id="fields"
              required
              value={fields}
              onChange={(event, newValue) => {
                onChange(newValue);
                setFields([
                  ...fixedOptions,
                  ...newValue.filter(
                    (option) => fixedOptions.indexOf(option) === -1
                  ),
                ]);
              }}
              options={fieldsfb}
              getOptionLabel={(option) => option}
              isOptionEqualToValue={(option, value) => option === value}
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip
                    label={option}
                    {...getTagProps({ index })}
                    disabled={fixedOptions.indexOf(option) === 0}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  classes={{ root: "MuiTextField-root" }}
                  placeholder="Adicione seus fields"
                  onChange={onChange}
                />
              )}
            />
          )}
        />
      </Stack>

      <label htmlFor="date">Início da extração:</label>
      <input
        type="date"
        id="date"
        required
        max={new Date().toISOString().split("T")[0]}
        name="date"
        {...register("date")}
      />

      <label htmlFor="description">Descrição da extração</label>
      <textarea
        minLength={10}
        id="description"
        name="description"
        placeholder="Descreva brevemente sua extração."
        required
        wrap="true"
        {...register("description")}
      />

      <button type="submit">Enviar Extração</button>
    </Form>
  );
}
